import React, { useEffect, useState, useRef } from "react";
// import { resolveColorStyle } from '../../_helpers';
import { useFormContext, useWatch } from "react-hook-form";
import ReactTooltip from "react-tooltip";
import { DEFAULT_MARKER_IMAGE } from "../../_helpers";

export function CustomMarkerPreview({
  isImageMode = true,
  markerImage,
  primaryColor = null,
  keyPrefix = "",
  filter = null,
}) {
  ReactTooltip.rebuild();
  // const [filterStyle, setFilterStyle] = useState('');
  const [anchorOffsets, setAnchorOffsets] = useState({ x: 0, y: 0 });

  const anchorRef = useRef();
  const containerRef = useRef();

  const tooltipID = "chronosCustomMarkerHotspot";

  const prefix = `https://www.worldanvil.com/`;
  const imagePath =
    isImageMode && markerImage && markerImage?.path?.length
      ? `${prefix}${markerImage.path}`
      : markerImage && markerImage.length
      ? markerImage
      : `${prefix}${DEFAULT_MARKER_IMAGE.path}`;

  // const { control } = useFormContext();
  const formContext = useFormContext();
  if (!formContext || formContext === null) {
    return null;
  }
  const prefixKey = (key) => {
    return keyPrefix.length > 0 ? `${keyPrefix}.${key}` : key;
  };

  const { control, setValue } = formContext;
  // const filter = useWatch({ control, name: prefixKey('filter') });
  const posX = useWatch({ control, name: prefixKey("anchorX") });
  const posY = useWatch({ control, name: prefixKey("anchorY") });
  const width = useWatch({ control, name: prefixKey("width") });
  const height = useWatch({ control, name: prefixKey("height") });

  // useEffect(() => {
  //   if (primaryColor !== null && primaryColor !== '') {
  //     // generateFilterStyle(primaryColor);
  //     // let newFilter = resolveColorStyle(primaryColor.slice());
  //     // setFilterStyle(newFilter.filter);
  //   } else {
  //     setFilterStyle('');
  //   }
  // }, [primaryColor]);

  // useEffect(() => {
  //   setFilterStyle(filter);
  // }, [filter]);

  useEffect(() => {
    if (containerRef && containerRef.current) {
      let offsetX =
        ((containerRef.current.clientWidth || 120) - (width || 40)) / 2;
      let offsetY =
        ((containerRef.current.clientHeight || 120) - (height || 40)) / 2;
      setAnchorOffsets({ x: offsetX, y: offsetY });
      // console.log({ x: offsetX, y: offsetY });
      // console.dir(containerRef.current);
    }
    // console.log(width, height, posX, posY);
  }, [markerImage, width, height, posX, posY]);

  useEffect(() => {
    if (
      (markerImage &&
        markerImage.identifier &&
        markerImage.identifier === "default") ||
      markerImage === null
    ) {
      setValue(prefixKey("width"), 24);
      setValue(prefixKey("anchorX"), 12);
      setValue(prefixKey("anchorY"), 40);
    }
  }, []);

  return (
    <div className="chronos-custom-icon-preview">
      <label className="chronos-form-title text-center">Preview</label>
      <div className="chronos-custom-marker-previewer" ref={containerRef}>
        <div
          className="chronos-custom-marker-hotspot"
          data-for={tooltipID}
          data-tip="This is the point the marker will use to 'stick'to the map."
          style={{
            top: anchorOffsets.y + posY,
            left: anchorOffsets.x + posX,
          }}
          ref={anchorRef}
        ></div>
        <img
          src={imagePath}
          className="chronos-custom-marker-image"
          // ref={imageRef}
          alt=""
          style={{ filter: filter !== null ? filter : "", width, height }}
        />
      </div>
      <div className="chronos-custom-marker-title"></div>
      <ReactTooltip id={tooltipID} effect="solid" />
    </div>
  );
}

// ('filter: invert(19%) sepia(91%) saturate(1723%) hue-rotate(339deg) brightness(106%) contrast(102%);');
